module.exports = __webpack_public_path__ + "static/media/Agenda11.65331e84.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagens/Agenda/Agenda11.png
// module id = 1975
// module chunks = 0